exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatarImg[data-v-a45ced3c] {\n  height: 40px;\n}\n.my-box .el-row[data-v-a45ced3c] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-a45ced3c]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-a45ced3c] {\n  border-radius: 4px;\n}\n.my-box .my-input[data-v-a45ced3c] {\n  max-width: 209px;\n}\n.checkBox[data-v-a45ced3c] {\n  display: inline-block;\n  width: 28%;\n}\n", ""]);

// exports
